import {
    Typography,
    Stack,
    Link,
} from '@mui/material';
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const ContactSection = () => (
    <Stack spacing={2}>
        {/* Email */}
        <Stack direction="row" alignItems="center" spacing={1}>
            <EmailIcon color="secondary"/>
            <Typography>Email: <Link href="mailto:cristian@hilohi.dev" underline="hover">
                cristian@hilohi.dev
            </Link>
            </Typography>
        </Stack>

        {/* Phone */}
        <Stack direction="row" alignItems="center" spacing={1}>
            <PhoneIcon color="secondary"/>
            <Typography>Phone:
                <Link href="tel:+40734564070" underline="hover">
                    +40 734 564 070
                </Link>
            </Typography>
        </Stack>

        {/* LinkedIn */}
        <Stack direction="row" alignItems="center" spacing={1}>
            <LinkedInIcon color="secondary"/>
            <Typography>
                <Link
                    href="https://www.linkedin.com/in/cristian-hilohi-216403198/"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                >
                    LinkedIn profile
                </Link></Typography>
        </Stack>
    </Stack>
)